import styled from "styled-components";
import { Space, Divider, Button } from "antd";

export const StyledVerticalSpace = styled(Space).attrs({
  direction: "vertical",
  size: "middle",
})``;

export const StyledHorizontalSpace = styled(Space).attrs({
  direction: "horizontal",
  size: "large",
})`
  width: 100%;

  .ant-space-item {
    width: 100%;
  }
`;

export const StyledInputWrapper = styled(Space).attrs({
  direction: "vertical",
  size: "small",
})``;

export const StyledInputLabel = styled.label`
  font-weight: 400;
  font-size: 14px;
`;

export const StyledHorizontalDivider = styled(Divider).attrs({
  type: "horizontal",
})`
  margin: 0.725rem 0;
`;
